/**
 * ProviderPage — Integration Hub
 * -----------------------------------------------------------------------------
 * Página fixa de um fornecedor/aplicativo do catálogo de integrações.
 * Todo o conteúdo vive em `ProviderDetailPanel`, compartilhado com o modal
 * "Aplicativos e integrações".
 *
 * @version 1.1.0
 * RELEASE: 2026-08-23 v1.1.0 - Passa a reutilizar ProviderDetailPanel.
 * RELEASE: 2026-08-23 v1.0.0 - Criação inicial (catálogo + múltiplas conexões).
 */

import { useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ProviderDetailPanel } from '@/components/data/ProviderDetailPanel';

export default function ProviderPage() {
  const { providerSlug = '' } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  /** Deep-link de edição: /tenant/data/connections/:slug?edit=<connectionId> */
  const editId = searchParams.get('edit');

  /** Remove o parâmetro após o modal de edição ser aberto */
  const handleEditConsumed = useCallback(() => {
    searchParams.delete('edit');
    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <ProviderDetailPanel
      providerSlug={providerSlug}
      variant="page"
      onBack={() => navigate('/tenant/data/connections')}
      initialEditConnectionId={editId}
      onInitialEditConsumed={handleEditConsumed}
    />
  );
}
